// @ts-strict

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, Subject } from 'rxjs';
import { BaseApiResponse, DefaultApiMessageResponse, ICampaignConfigFieldData } from '../../models/core-models';
import {
  CreatedConfigurationResponse,
  EditedConfig,
  IBannerDomainData,
  ICreateCampaignConfigResponse,
  ProgramConfigurationsResponse
} from './url-address-config.types';

@Injectable({
  providedIn: 'root'
})
export class UrlAddressConfigService {
  addedEditedConfig = new Subject<EditedConfig>();

  public isUrlEditClosed = true;

  constructor(private http: HttpClient) {}

  public getModalConfig(id: number): Observable<BaseApiResponse<ICreateCampaignConfigResponse>> {
    return this.http.get<BaseApiResponse<ICreateCampaignConfigResponse>>(environment.apiUrl + `/campaigns/${id}/configuration/create`);
  }

  /**
   * Get fields and values for edit config modal
   * @param campaignID id of current campaign
   * @param configID id of edited config
   * @returns observable with data
   */
  public getEditConfigData(campaignID: number, configID: number) {
    return this.http.get<BaseApiResponse<{ fields?: ICampaignConfigFieldData[]; landings?: { id: number; name: string }[] }>>(
      environment.apiUrl + `/campaigns/${campaignID}/configuration/${configID}/edit`
    );
  }

  // Post new configuration on server
  public addConfiguration(fields: Record<string, string | number | string[]>, programID: number) {
    return this.http.post<BaseApiResponse<CreatedConfigurationResponse>>(environment.apiUrl + `/campaigns/${programID}/configuration/store`, fields);
  }

  public editCurrentConfig(programID: number, fields: Record<string, string | number | string[]>) {
    return this.http.put<BaseApiResponse<CreatedConfigurationResponse>>(environment.apiUrl + `/campaigns/${programID}/configuration/update`, fields);
  }

  // Get all configurations from server
  public getAllConfigs(programID: number) {
    return this.http.get<BaseApiResponse<ProgramConfigurationsResponse>>(environment.apiUrl + `/campaigns/${programID}/configuration/list`);
  }

  public getProgramDomains(programID: number, configID: number, type: string): Observable<BaseApiResponse<{ domains?: IBannerDomainData[] }>> {
    return this.http.get<BaseApiResponse<{ domains?: IBannerDomainData[] }>>(environment.apiUrl + `/campaigns/${programID}/info/${configID}/domains`, {
      params: { type }
    });
  }

  public deleteProgramConfiguration(programID: number, configID: number): Observable<DefaultApiMessageResponse> {
    return this.http.delete<DefaultApiMessageResponse>(environment.apiUrl + `/campaigns/${programID}/configuration/delete`, {
      params: { config_id: configID }
    });
  }
}
